<app-menumobile *ngIf="!showHeaderB()"></app-menumobile>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>

<div>
  <div class="content-wrap">
    <div
      class="content"
      id="top"
    >
      <app-header
        *ngIf="!showHeaderB()"
        [UserName]="firstName"
      ></app-header>
      <app-headerLogin *ngIf="showHeaderB()"></app-headerLogin>

      <main class="container site-container">
        <router-outlet></router-outlet>
      </main>

      <footer [ngClass]="getfooterStyle()">
        <div class="footer-wrapper">
          <div class="col-xs-12 footer-idiomas idiomas-mobile">
            <label for="slct">Idioma</label>
            <div class="select">
              <select
                name="slct"
                class="slct"
              >
                <option value="0">Castellano</option>
              </select>
            </div>
          </div>
          <div class="tal">
            <ul>
              <li>
                <p>&copy; {{pie}} {{currentYear}}</p>
              </li>
              <li>
                <span
                  class="modal-footer-options"
                  (click)="CargarCondicioneslegales()"
                >
                  Condiciones Legales
                </span>
              </li>
              <li>
                <span
                  class="modal-footer-options"
                  (click)="CargarPoliticaPrivacidad()"
                >
                  Política de Privacidad
                </span>
              </li>
              <li>
                <span
                  class="modal-footer-options"
                  (click)="getImpresos()"
                >
                  Impresos
                </span>
              </li>
              <!--li>
                  <a [routerLink]="['/home/faq']" class="nav-link" href="#">Preguntas Frecuentes</a>
                </li-->
            </ul>
          </div>

          <div class="footer-idiomas idiomas-desktop">
            <label for="slct">Idioma</label>
            <div class="select">
              <select
                name="slct"
                class="slct"
              >
                <option value="0">Castellano</option>
              </select>
            </div>
          </div>

        </div>
      </footer>
    </div>
  </div>
</div>

<!-- MODAL -->
<sacyr-modal
  [setTemplateRef]="modal_content"
  [showModal]="showModal()"
  (closeModal)="closeModal()"
></sacyr-modal>

<ng-template #modal_content>

  <ng-container *ngIf="_showModalCondiciones">
    <h1>Condiciones Legales</h1>
    <div [innerHTML]="condiciones"></div>
  </ng-container>

  <ng-container *ngIf="_showModalPolitica">
    <h1>Política de privacidad</h1>
    <div [innerHTML]="politica"></div>
  </ng-container>

  <ng-container *ngIf="_showModalImpresos">
    <h2>Descarga de impresos</h2>
    <div class="modal-impresos__texto">
      <div class="scy-table">
        <span
          class="msg error"
          *ngIf="msgErrorDescarga"
        >
          Se ha producido un error al descargar el fichero. Contacte con soporte si el problema persiste.
        </span>
        <div
          id="tabla-impresos_wrapper"
          class="dataTables_wrapper no-footer"
        >

          <ng-container *ngIf="isMobile; else elseTemplate">

            <div
              class="table-detail-expanded"
              *ngFor="let row of rows"
            >

              <div class="row with-background">
                <label class="row-detail-flex-title">Nombre</label>
                <div class="row-detail-flex-data">
                  {{ getRowItem(row).descripcion }}
                </div>
              </div>

              <div class="row">
                <label class="row-detail-flex-title">PDF</label>
                <div class="row-detail-flex-data">

                  <a
                    class="table-cell-img-text"
                    (click)="DescargarFichero(getRowItem(row))"
                  >
                    <img
                      class="descarga-mobile"
                      src="./assets/images/icons/factura.svg"
                      alt="Descargar factura en pdf"
                    >
                    <span class="descarga-desktop">Descargar</span>
                  </a>

                </div>
              </div>

            </div>

          </ng-container>
          <ng-template #elseTemplate>

            <!-- NGX-DATATABLE -->

            <ngx-datatable
              #myTable
              class="material expandable"
              [ngClass]="{'fullscreen': _tableFullscreen}"
              [columnMode]="_columnMode"
              [headerHeight]="50"
              [footerHeight]="50"
              [rowHeight]="50"
              [scrollbarV]="true"
              [rows]="rows"
            >
              <ngx-datatable-column
                name="Nombre"
                [flexGrow]="1"
                [minWidth]="100"
                [sortable]="false"
              >
                <ng-template ngx-datatable-header-template>
                  <span class="not-sortable">Nombre</span>
                </ng-template>

                <ng-template
                  let-row="row"
                  let-value="value"
                  ngx-datatable-cell-template
                >
                  {{ getRowItem(row).descripcion }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="PDF"
                [flexGrow]="1"
                [minWidth]="100"
                [sortable]="false"
              >
                <ng-template ngx-datatable-header-template>
                  <span class="mobile-hidden not-sortable">PDF</span>
                  <span class="desktop-hidden"></span>
                </ng-template>

                <ng-template
                  let-row="row"
                  let-value="value"
                  ngx-datatable-cell-template
                >
                  <div [ngClass]="{'mobile-hidden': true}">

                    <div class="pdf">
                      <a
                        class="table-cell-img-text"
                        (click)="DescargarFichero(getRowItem(row))"
                      >
                        <img
                          class="descarga-mobile"
                          src="./assets/images/icons/factura.svg"
                          alt="Descargar factura en pdf"
                        >
                        <span
                          class="descarga-desktop auto-fade"
                          [ngClass]="{'hide': isMobile}"
                        >Descargar</span>
                      </a>
                    </div>

                  </div>
                </ng-template>
              </ngx-datatable-column>

            </ngx-datatable>

          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>

</ng-template>

<sacyr-cookie-law (outStoreGoogleCookies)="onLoadGoogleCookies($event)"></sacyr-cookie-law>

<script>
  (function () {
    App.init();
    Chart.init();
  })();
</script>
